import { useEffect } from "react";
import { GC } from "services/gamecentreService";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import AppRouter from "./router";

import "./App.css";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  enabled:true,
  // Called immediately before the event is sent to the server, 
  // Last chance to decide not to send data or to edit it. 
  // beforeSend receives the event object as a parameter, which can use to either modify the event’s data.
  // If return null, the event will be discarded.
  beforeSend(event) {
    if (event?.message === "Sentry log initiated.") {
      // Dropping event -> Explaination in captureSentryEvent()
      return null;
    }
    // console.log('Logging to sentry,');
    return event;
  },
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  sampleRate: 1.0
});


function App() {
  useEffect(() => {
    if (window.location === window.parent.location) {
      // Not calling gamecenter apis if not loaded in it.
      return;
    }

    // Adding timeout to handle React.18 intentinonal re-render on development
    const timeout = setTimeout(() => {
      window.addEventListener("message", GC.messageEventHandler);

      GC.sendGameLoadMessage();
    }, 0);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("message", GC.messageEventHandler);
    };
  }, []);

  return (
    <Sentry.ErrorBoundary
      onError={(err) => console.log(err)}
      fallback={<p>An error has occurred</p>}
    >
      <AppRouter />
    </Sentry.ErrorBoundary>
  )
}

export default App;
